import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { ExaminationApi } from "../../../api/examination-master/examination-master.api";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
   
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("MANAGE_EXAMS_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("MANAGE_EXAMS_TYPE")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("MANAGE_EXAMS_TOTAL_QUESTIONS")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("MANAGE_EXAMS_TOTAL_SCORE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("MANAGE_EXAMS_LAST_UPDATED")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("MANAGE_EXAMS_LAST_UPDATED_BY")
        },

        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 180, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            examination_name,
            examination_types,
            created_date,
            modified_date,
            total_score,
            total_detail,
            modified_by,
            id_examination
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "left",
                    label: examination_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: examination_types || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: total_detail || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: total_score || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.manage_exams_detail.replace(':id', id_examination))}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => navigate(routeName.admission.manage_exams_view.replace(':id', id_examination))}
                            onEditClick={() => navigate(routeName.admission.manage_exams_detail.replace(':id', id_examination))}
                            onDeleteClick={() => handleDeleteList(id_examination)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_examination: number) => {
        alertActive(t("MANAGE_EXAMS_DELETE"), t("MANAGE_EXAMS_CONFIRM_DELETE"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ExaminationApi.deleteExamination(id_examination).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("MANAGE_EXAMS_DELETE"), t("MANAGE_EXAMS_DELETE_COMPLETED"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("MANAGE_EXAMS_DELETE"), t("MANAGE_EXAMS_DELETE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await ExaminationApi.getExaminationList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        
    }
}

export default ManageState